import { createContext, useContext, useState } from 'react';
import { MemberType } from '@apis/lib/member';

type MemberContextType =
    | {
          member: MemberType | undefined;
          setMember: React.Dispatch<React.SetStateAction<MemberType | undefined>>;
      }
    | undefined;
const MemberContext = createContext<MemberContextType>(undefined);

interface MemberProviderProps {
    children: React.ReactNode;
}
export const MemberProvider = ({ children }: MemberProviderProps) => {
    const [member, setMember] = useState<MemberType | undefined>();

    const value = { member, setMember };
    return <MemberContext.Provider value={value}>{children}</MemberContext.Provider>;
};

export const useMemberContext = () => {
    const context = useContext(MemberContext);
    if (context === undefined) {
        throw new Error('useMemberContext must be use within a MemberProvider');
    }
    return context;
};
